import React from 'react';

import { ControlPageBlock, TextAreaField } from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

export default class RawHtmlEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                loading: true,
                email: '',
                nick: '',
                like_hammer: 0,
            },
            not_valid: {},
        };
        this.handleData = this.handleData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);

        if (props.match.params.id) {
            this.state.API_ENDPOINT = `rawhtml/${props.match.params.id}/`;
        } else {
            this.setState({});
            this.state.API_ENDPOINT = 'rawhtml/';
            this.EDITABLE_EMAIL = true;
        }
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    sendData(event) {
        this.validate();
        const save_type = event.currentTarget.id;

        let request_method = 'PUT';

        if (!this.props.match.params.id) {
            request_method = 'POST';
        }

        // TODO: sorry about that, but its all about DB structure
        if (!this.state.data.like_hammer) {
            const new_state = this.state;
            new_state.data.like_hammer = 0;
            this.setState(new_state);
        }

        //
        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        if (!this.props.match.params.id) {
            callback = this.goToNewPage;
        }

        Fetcher(this.state.API_ENDPOINT, request_method, callback, this.state.data);
    }

    goToNewPage(newData) {
        this.setState({ API_ENDPOINT: `rawhtml/${newData.id}/` });
        this.props.history.push(`${PROJECT_PREFIX}/rawhtml/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/rawhtml/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    handleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                loading: false,
                data: {
                    html: '',
                },
            });
        }
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['html'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    render() {
        return (
            <div>
                <TextAreaField
                    label="HTML"
                    name="html"
                    onChange={this.handleChange}
                    value={this.state.data.html}
                    required
                    is_not_valid={this.state.not_valid.html || false}
                />
                <div className="container-fluid">
                    <ControlPageBlock
                        name={this.state.data.id}
                        onSave={this.sendData}
                        onApply={this.sendData}
                        onCancel={this.goToPreviousPage}
                        onRemove={this.removeData}
                    />
                </div>
            </div>
        );
    }
}
